import { useMemo, useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import { getQuickCampaigns } from "../../api/StatsAPI";
import { usePrmStore } from "../../stores/PrmStore";
import MultiSelector from "./MultiSelector";
import { Group, Tooltip } from "@mantine/core";
import { IconArchive } from "@tabler/icons-react";
import { requestPage } from "../../api/ContactAPI";
import { useLeadsStore } from "../../stores/LeadsStore";

function getOptionName(option) {
  return `${option.workflow_name} #${option.id}`;
}

const CampaignsSelector = ({
  label,
  placeholder,
  size,
  values,
  onChange,
  disabled,
  ...props
}) => {
  const lang = useLanguage((s) => s.language);
  const campaigns = usePrmStore((s) => s.campaignOptions);
  const [loading, setLoading] = useState(false);
  const [nextUrl, setNextUrl] = useState(null);
  const handleLoad = (e) => {
    setLoading(true);
    getQuickCampaigns()
      .then((r) => {
        setNextUrl(r.data.next_page);
      })
      .finally(() => setLoading(false));
  };

  const handleNext = (e) => {
    setLoading(true);
    requestPage(nextUrl, 0, true)
      .then((response) => {
        let responseResults = response.data.results;
        let newResults = [...campaigns, ...responseResults];
        usePrmStore.getState().setCampaignOptions(newResults);
        let setPrmOptions = useLeadsStore.getState().setCampaignOptions;
        setPrmOptions([
          {
            label: useLanguage.getState().language.prm.filter_labels.campaign,
            options:
              newResults
                ?.sort((a, b) => b.id - a.id)
                ?.map((x) => ({ ...x, option_name: x["workflow_name"] })) || [],
          },
        ]);
        setNextUrl(response.data.next_page);
      })
      .finally(() => setLoading(false));
  };

  const options = useMemo(() => {
    return campaigns
      .sort((a, b) => b.archived)
      .map((item) => ({
        ...item,
        option_name: getOptionName(item),
      }));
  }, [campaigns]);

  return (
    <MultiSelector
      options={options}
      label={label}
      onDropdownOpen={handleLoad}
      loading={loading}
      values={values}
      onChange={onChange}
      placeholder={placeholder}
      dropdownHeight={200}
      rightOptionSection={(item) => {
        return (
          <Group wrap="nowrap">
            {item.archived && (
              <Tooltip label={lang.statistics.filters.archived} withArrow>
                <IconArchive color="red" size={18} stroke={1.1} />
              </Tooltip>
            )}
            <Tooltip label={"Date d'envoi"} withArrow>
              <span style={{ fontSize: 10, opacity: 0.35, width: 75 }}>
                {new Date(item.date_start).toLocaleString(
                  lang.id === "FRA" ? "fr-FR" : "en-EN",
                  {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }
                )}
              </span>
            </Tooltip>
          </Group>
        );
      }}
      size={size}
      disabled={disabled}
      w={"100%"}
      searchable
      checkIconPosition="left"
      withDropdown
      option_name_props={{
        w: "80%",
      }}
      maxInputHeight={"none"}
      autoFocus={false}
      limitPills={1}
      nextUrl={nextUrl}
      handleNext={handleNext}
      {...props}
    />
  );
};

export default CampaignsSelector;
